export const COLOR_SCHEME = Object.freeze({
  ALERT: "#b72025",
  ALERT_BRIGHT: "#ff1744",
  ACCENT_TABLE_ROW: "#ecc0c1",
  ACCENT_BLUE: "#d6dde7",
  DARK_BLUE: "#567D88",
  BLUE: "#567db8",
  GREY: "#e3e3e3",
  LIGHT_GREY: "#ececec",
  BLUE2: "#426ba6",
});
